import { render } from "./ModalChangePhone.vue?vue&type=template&id=edc54ffa"
import script from "./ModalChangePhone.vue?vue&type=script&lang=js"
export * from "./ModalChangePhone.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__